<canvas class="animation-canvas" #myCanvas [width]="width" [height]="height"></canvas>